import React, { useState, useEffect, useRef, useContext } from 'react';
import { StoreContext } from '../../store';
import './index.css';

import { Rating } from 'react-simple-star-rating';
import ClickOutsideHandler from '../../utility/ClickOutsideHandler';

import Banner from '../../assets/home-page/banner.png';

import { ReactComponent as Play } from '../../assets/play-icon.svg';
import { ReactComponent as CloseIcon } from '../../assets/cancel-white.svg';
import { ReactComponent as Search } from '../../assets/search.svg';
import { ReactComponent as Target } from '../../assets/target.svg';
import WRIcon1 from '../../assets/landing-page/real-estate/walking-radius1.png';
import WRIcon2 from '../../assets/landing-page/real-estate/walking-radius2.png';
import WRIcon3 from '../../assets/landing-page/real-estate/walking-radius3.png';
import GemScore from '../../assets/home-page/scores/gem-score.png';
import FeelScore from '../../assets/home-page/scores/feel-score.png';
// other features
import QuickSearch from '../../assets/quick-search.svg';
import DataAnalytic from '../../assets/landing-page/real-estate/other-features/data-analytics.svg';
import Summary from '../../assets/landing-page/real-estate/other-features/summary.svg';
import RatingIcon from '../../assets/landing-page/real-estate/other-features/rating.png';
import Carbon from '../../assets/landing-page/real-estate/other-features/carbon-f.png';
import Health from '../../assets/landing-page/real-estate/other-features/health.png';
import Navigation from '../../assets/landing-page/real-estate/other-features/navigation.png';
import Filter from '../../assets/landing-page/real-estate/other-features/filter.png';
import WhiteLable from '../../assets/landing-page/real-estate/other-features/white-label.png';
import Custom from '../../assets/landing-page/real-estate/other-features/custom.png';
import Comparison from '../../assets/landing-page/Tab/tab5.svg';
import GemReport from '../../assets/home-page/report/gem-report.png';
import FeelReport from '../../assets/home-page/report/feel-report.png';

import {
  walkIndexFeatures,
  lifeStyleFeatures,
  partnersData,
  impactData,
  neighborhoodIntelTabs,
  neighborhoodSearchFeatures,
  testimonialsData,
} from '../../constants';

import { fetchPlaceDetails } from '../../api';
import { saveAddressToRecentlyViewed, debounce, scrollToTop } from '../../services';

import Slider from 'react-slick';
import Show from '../../utility/Show';

const Home = () => {
  const { state, actions, dispatch, navigate } = useContext(StoreContext);
  const { isGoogleMapsLoaded, isMobile, recentlyViewedAddresses, currentCity, currentView } = state;
  const [currentTab, setCurrentTab] = useState(0);
  const [predictions, setPredictions] = useState([]);
  const [showIframe, setShowIframe] = useState(false);
  const [showVideo, setShowVideo] = useState(false);
  const inputRef = useRef();
  let sliderRef = useRef(null);
  const iframeRef = useRef(null);
  const placeholderRef = useRef(null);

  const walkingRadius = [
    {
      distance: "0.25 mi",
      time: "5 min walk",
      image: WRIcon1,
      className: "w-16 h-16"
    },
    {
      distance: "0.50 mi",
      time: "10 min walk",
      image: WRIcon2,
      className: "w-24 h-24"
    },
    {
      distance: "1.0 mi",
      time: "20 min walk",
      image: WRIcon3,
      className: "w-40 h-40"
    },
  ];

  const features = [
    {
      id: 1,
      title: "Data Analytics",
      icon: DataAnalytic,
      className: '2xs:h-8 md:h-12 w-auto m-auto'
    },
    {
      id: 2,
      title: "Summary Report",
      icon: Summary,
      className: '2xs:h-8 md:h-12 w-auto m-auto'
    },
    {
      id: 3,
      title: "White Label",
      icon: WhiteLable,
      className: 'h-20 w-auto m-auto'
    },
    {
      id: 4,
      title: "Customization",
      icon: Custom,
      className: 'h-12 w-auto m-auto'
    },
    {
      id: 5,
      title: "Rating",
      icon: RatingIcon,
      className: 'h-6 w-auto m-auto'
    },
    {
      id: 6,
      title: "Navigation",
      icon: Navigation,
      className: 'h-24 w-auto m-auto'
    },
    {
      id: 7,
      title: "Carbon Footprint",
      icon: Carbon,
      className: 'h-24 w-auto m-auto'
    },
    {
      id: 8,
      title: "Filters",
      icon: Filter,
      className: 'h-10 w-auto m-auto'
    },
    {
      id: 9,
      title: "Health",
      icon: Health,
      className: '2xs:h-16 md:h-24 w-auto m-auto'
    },
  ];

  const otherFeatures = () => {
    return (
      <div className="bg-black py-16">
        <h2 className="text-white text-center 2xs:text-xl md:text-3xl font-medium 2xs:mb-6 md:mb-12">
          OTHER FEATURES
        </h2>
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 2xs:gap-4 md:gap-8 px-4">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="flex flex-col items-center bg-[#0D0D0D] p-6 text-white text-center shadow-lg aspect-square 2xs:w-[220px] md:w-[100%] m-auto"
            >
              <img
                src={feature.icon}
                alt={feature.title}
                className={feature.className}
              />
              <h3 className="text-lg md:text-2xl font-medium mb-10">{feature.title}</h3>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const NeighborhoodIntelTabs = () => {
    const settings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      swipe: false,
      adaptiveHeight: isMobile ? true : false,
    };

    const handleTabClick = (index) => {
      setCurrentTab(index);
    };

    useEffect(() => {
      if (sliderRef) {
        sliderRef.slickGoTo(currentTab);
      }
    }, [currentTab]);

    return (
      <div className='neighborhood-intel-tabs'>
        <h1 className='landing-title 2xs:text-xl'>YOUR NEIGHBORHOOD RECOMMENDATION SYSTEM</h1>
        <div className='tabs'>
          {neighborhoodIntelTabs.map((tab, index) => (
            <div
              key={index}
              className={`tab ${currentTab === index ? 'active' : ''}`}
              onClick={() => handleTabClick(index)}
            >
              {tab.name}
            </div>
          ))}
        </div>
        <Slider
          ref={(slider) => {
            sliderRef = slider;
          }}
          {...settings}
        >
          {neighborhoodIntelTabs.map((tab, index) => (
            <div
              key={index}
              className={`tab-content ${tab.name === 'Scoring' && 'scoring'}`}
            >
              <Show>
                <Show.When isTrue={tab.name === 'Scoring'}>
                  <img src={tab.img1} alt={tab.name} />
                  <img src={tab.img2} alt={tab.name} />
                </Show.When>
                <Show.Else>
                  <img src={tab.img} alt={tab.name} />
                </Show.Else>
              </Show>
            </div>
          ))}
        </Slider>
      </div>
    );
  };

  const searchAddress = () => {
    if (isGoogleMapsLoaded) {
      const autocompleteService =
        new window.google.maps.places.AutocompleteService();
      if (autocompleteService && inputRef.current) {
        const inputText = inputRef.current.value;
        const city = currentCity ? `${currentCity}, ` : '';

        autocompleteService.getPlacePredictions(
          {
            input: city + inputText,
            types: ['geocode'], // You can specify the types of predictions you want
          },
          async (predictions, status) => {
            if (status === window.google.maps.places.PlacesServiceStatus.OK && predictions) {
              try {
                // Fetch details for each prediction
                const detailedPredictions = await Promise.all(predictions.map(async (prediction) => {
                  try {
                    const details = await fetchPlaceDetails(prediction.place_id);
                    return {
                      ...prediction,
                      latitude: details.geometry.location.lat(),
                      longitude: details.geometry.location.lng(),
                    };
                  } catch (error) {
                    console.error(`Failed to fetch details for place_id ${prediction.place_id}:`, error);
                    return null;
                  }
                }));

                // Filter out any null results (in case some place details couldn't be fetched)
                const validPredictions = detailedPredictions.filter(prediction => prediction !== null);
                setPredictions(validPredictions);
              } catch (error) {
                console.error('Error fetching place details:', error);
                setPredictions([]);
              }
            } else {
              setPredictions([]);
            }
          }
        );
      }
    }
  };

  const replaceWithDashes = (str) => {
    // Replace non-alphanumeric characters with dashes
    let result = str.replace(/[^a-zA-Z0-9]/g, '-');
    // Replace multiple consecutive dashes with a single dash
    result = result.replace(/-+/g, '-');
    // Remove leading and trailing dashes if any
    result = result.replace(/^-|-$/g, '');
    return result;
  };

  const addressClick = async (address) => {
    // actions.sendDataToGoogleAnalytics('used_address_search', {});
    dispatch({ type: 'SET_SHOW_SEARCH_ADDRESS', payload: false });
    // const data = await actions.fetchAddressData(address.description, false, true)

    // saveAddressToRecentlyViewed(data, recentlyViewedAddresses, dispatch);

    // await actions.fetchAddressData(address);
    // navigate(`/address/${replaceWithDashes(address.description)}`);
    const newAddress = `address/${replaceWithDashes(address.description)}`;
    const baseUrl = window.location.origin;
    console.log('address clicked', address.description);
    window.location.replace(`${baseUrl}/${newAddress}`);
  };

  const handleSearchChange = (event) => {
    if (!event.target.value) {
      setPredictions([]);
    } else {
      searchAddress();
    }
  };

  const getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          actions.handleLogin();
          const lat = position.coords.latitude;
          const lng = position.coords.longitude;
          actions.fetchAddressByLatLng(lat, lng);
          navigate(`/plugin`);
        },
        (error) => {
          console.log(error);
        }
      );
    } else {
      console.log('Geolocation is not supported by this browser.');
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setShowIframe(false);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.5 } // Adjust this value as needed
    );

    if (placeholderRef.current) {
      observer.observe(placeholderRef.current);
    }

    document.title = 'Home - Walkspan';

    return () => {
      if (placeholderRef.current) {
        observer.unobserve(placeholderRef.current);
      }
    };
  }, []);

  const handleLoadFrame = () => {
    setTimeout(() => {
      setShowIframe(true);
    }, 1000);
  };

  const bannerFeatures = [
    "Single Interface",
    "Scoring",
    "Mapping",
    "Reporting",
    "Recommendation",
  ];

  const HomeBanner = () => {
    const gotoContactUs = () => {
      scrollToTop();
      navigate('/contact-us');
      document.title = 'Contact Us - Walkspan';
    };

    const handleShowVideo = () => {
      setShowVideo(!showVideo);
    };

    return (
      <div className='home-banner'>
        <Show.When isTrue={true}>
          <img
            ref={placeholderRef}
            className='banner-placeholder'
            src={Banner}
            alt='Loading video...'
          />
        </Show.When>
        <Show.When isTrue={showVideo}>
          <div className="fixed top-0 left-0 w-full !h-[100svh] bg-black bg-opacity-80 flex justify-center items-center z-50">
            <CloseIcon className='absolute top-4 right-4 h-5 w-auto cursor-pointer' />
            <ClickOutsideHandler onOutsideClick={() => handleShowVideo()}>
              <iframe
                width="100%"
                height="auto"
                src="https://player.vimeo.com/video/1058236664?h=b756f18907&badge=0&autopause=0&player_id=0&app_id=58479&byline=0&portrait=0&title=0&ui=0"
                frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
                className="rounded-lg 2xs:w-[80svw] md:w-[100svw] 2xs:h-[25svh] md:h-[50svh]"
              ></iframe>
            </ClickOutsideHandler>
          </div>
        </Show.When>
        <div className='max-w-screen-lg'>
          <div className='banner-content '>
            <div className='text-2xl 2xs:text-xl lg:text-5xl drop-shadow-2xl font-medium'>Neighborhood Intelligence</div>
            <div className='w-full flex flex-col gap-4 justify-center items-center'>
              <span className='text-xl lg:text-[28px]'>Find your neighborhood</span>
              <div className='search-address-input !p-2'>
                {/* <div
                  onClick={() => getLocation()}
                  className='current-location-icon'
                >
                  <Target />
                </div> */}
                <input
                  className='text-black'
                  ref={inputRef}
                  onChange={(e) => handleSearchChange(e)}
                  placeholder='Search any address, neighborhood or city ...'
                />
                <div className='modern-search-address-btn'>
                  <Search />
                </div>
                <Show>
                  <Show.When isTrue={predictions.length !== 0}>
                    <div
                      className={`prediction-container ${
                        currentView === 'Modern' && 'modern-prediction-container'
                      }`}
                    >
                      {predictions.map((prediction) => (
                        <div
                          className='prediction'
                          key={prediction.place_id}
                          onClick={() => addressClick(prediction)}
                        >
                          {prediction.description}
                        </div>
                      ))}
                    </div>
                  </Show.When>
                </Show>
              </div>
            </div>
            <div className='features p-4 w-full 2xs:max-w-[365px] md:max-w-[850px]'>
              {bannerFeatures.map((feature, index) => (
                <React.Fragment key={index}>
                  <div className='p-2'>{feature}</div>
                  {index < bannerFeatures.length - 1 && (
                  <div className='2xs:h-[1px] md:h-full 2xs:w-full md:w-[1px] bg-white mx-4'></div>
                  )}
                </React.Fragment>
              ))}
            </div>
            <div className='flex 2xs:flex-col md:flex-row gap-2'>
              <div
                className='req-demo w-auto 2xs:p-3 md:p-4 2xs:text-sm md:text-xl cursor-pointer hover:!bg-white hover:text-black flex gap-2 items-center'
                onClick={() => handleShowVideo()}
              >
                <Play className='!h-[20px] w-auto' /> Watch our video
              </div>
              <div
                className='req-demo w-auto 2xs:p-3 md:p-4 2xs:text-sm md:text-xl cursor-pointer hover:!bg-white hover:text-black'
                onClick={() => gotoContactUs()}
              >
                Book a Demo
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const Searches = () => {
    const searchFeatures = [
      "Summary",
      "Quick",
      "Detailed",
      "Combined",
      "Filter",
      "Compare",
    ];

    const filterGemFeatures = lifeStyleFeatures.slice(1, -1);

    const gemEstablishments = {
      food: ["Restaurants", "Cafe", "Grocery", "Bar", "Fast Food"],
      services: ["Schools", "Church", "Medical", "Bank", "Pet", "Dental", "Laundry"],
      shops: ["Clothing", "Hardware", "Shoes", "Beauty", "Liquor", "Pharmacy", "Pet Shop"],
      transit: ["Subway", "Bus", "Bike", "Train", "Ferry"],
      leisure: ["Theater", "Galleries", "Play ground", "Garden", "Fitness", "Clubs", "Museum", "Parks"],
    };

    return (
      <div className='search-section flex flex-col gap-4 py-10'>
        <div className='text-[28px] font-medium'>Searches</div>
        <div className='flex gap-4 justify-center items-center flex-wrap bg-[#211F1F] text-white'>
          {searchFeatures.map((feature, index) => (
            <React.Fragment key={index}>
              <div className='py-4 px-5'>
                {feature}
              </div>
              {index < searchFeatures.length - 1 && (
                <div className='h-full w-[1px] bg-white mx-4'></div>
              )}
            </React.Fragment>
          ))}
        </div>
        <div className='flex flex-col gap-4 p-6'>
          <div>
            <div className='text-[28px] font-medium'>WHAT WE MAP</div>
            <div>at 5-10-20 minute walk</div>
          </div>
          <div>
            <div className='text-xl font-medium mb-4'>Lifestyle Essentials</div>
            <div className='flex gap-12 justify-center items-start flex-wrap'>
              {filterGemFeatures.map((feature, index) => {
                const featureColor = {
                  '--feature-color': feature.color,
                };
                return (
                  <div key={index} style={featureColor}>
                    <div className='flex flex-col gap-2 justify-center items-center mb-4'>
                      {feature.svg}
                      {feature.name}
                    </div>
                    <div className='flex flex-col flex-wrap gap-2 justify-center text-left'>
                      {gemEstablishments[feature.id]?.map((establishment, idx) => (
                        <div key={idx} className='text-left'>
                          {establishment}
                        </div>
                      ))}
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
          <div>
            <div className='text-xl font-medium mb-4'>Sidewalk Character</div>
            <div className='flex gap-12 justify-center items-start flex-wrap'>
              {walkIndexFeatures.map((feature, index) => {
                const featureColor = {
                  '--feature-color': feature.color,
                };
                return (
                  <div key={index} style={featureColor}>
                    <div className='flex flex-col gap-2 justify-center items-center mb-4'>
                      {feature.svg}
                      {feature.name}
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    )
  }

  const NeighborhoodSearch = () => {
    return (
      <div className='home-neighborhood-search'>
        <div className='max-w-screen-lg'>
          <div className='title'>neighborhood search</div>
          <div className='ns-features'>
            {neighborhoodSearchFeatures.map((feature, index) => (
              <div>
                <div className='ns-feature-title'>{feature.name}</div>
                <div className='ns-feature-desc'>{feature.description}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  const ImpactStartup = () => {
    return (
      <section className='impact-startup max-w-screen-lg'>
        <h1 className='landing-title'>WALKSPAN IS AN IMPACT STARTUP</h1>
        <div className='description'>
          Our business is designed to solve environmental and societal problems.
          Buying homes where lifestyle essentials are within walking reach will
          generate positive sustainable impacts.
        </div>
        <div className='impact-list'>
          {impactData.map((impact, index) => (
            <div key={index} className='impact-item'>
              <img src={impact.img} alt='Impact' />
              <p>{impact.description}</p>
            </div>
          ))}
        </div>
      </section>
    );
  };

  const Partners = () => {
    return (
      <section className='partners'>
        <div className='max-w-screen-lg'>
          <h1 className='landing-title'>Our Partners</h1>
          <div className='partners-list'>
            {partnersData.map((partner, index) => (
              <div key={index} className='partner-item'>
                <img src={partner.img} alt={partner.name} />
                <h3>{partner.name}</h3>
                <p>{partner.description}</p>
                <a
                  href={partner.link}
                  target='_blank'
                  rel='noopener noreferrer'
                  className='landing-view-btn'
                >
                  Visit Website
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  };

  const Testimonials = () => {
    return (
      <div className='testimonials-wrapper'>
          <div className='max-w-screen-lg relative'>
            <h1 className='2xs:text-xl md:text-3xl uppercase lg:mb-16 mb-8'>Testimonials</h1>
            <div className='flex 2xs:flex-col md:flex-row gap-6 mb-12'>
              {testimonialsData.map((data, index) => (
                <div className='flex flex-col items-center'>
                  <img src={data.img} alt={`testimonila-${index+1}`} />
                  <div className='mt-2 font-medium'>{data.name}</div>
                  <div className='text-sm font-light mb-6 text-gray-400'>{data.title}</div>
                  <div className='mt-2 2xs:my-2 text-sm italic'>“{data.msg}”</div>
                </div>
              ))}
            </div>
            {/* <div className='rounded bg-white text-black w-fit mx-auto py-2 px-6 font-medium cursor-pointer'>
              View all
            </div> */}
          </div>
      </div>
    )
  };

  return (
    <div className='landing-home-container'>
      {HomeBanner()}
      {/* {NeighborhoodSearch()} */}
      <div className='w-full flex flex-col gap-8 bg-[#211F1F] text-white text-center py-10 2xs:px-[2rem] md:px-[9rem]'>
        <div className='text-[28px]'>Walkspan celebrates the power of place</div>
        <div className='leading-8 text-lg'>
          An <b>AI-driven location intelligence</b> platform designed to seamlessly complement the real estate property search engine. 
          It shows home seekers the neighborhood they desire. The platform operationalizes neighborhood search through 
          its patent issued single interface, scoring, mapping, reporting and recommendation system. 
        </div>
      </div>
      {Searches()}
      {/* Walking Radius */}
      <div className="bg-[#211F1F] text-center text-white py-12">
        <h2 className="text-[28px] font-medium mb-6 uppercase">Walking Radius</h2>
        <div className="flex 2xs:flex-col md:flex-row justify-center gap-8">
          {walkingRadius.map((radius, index) => (
            <div
              key={index}
              className="flex 2xs:flex-col md:flex-row items-center text-center gap-2"
            >
              <div className="flex flex-col 2xs:text-center md:text-right mr-2">
                <span className="text-lg mt-2 font-bold">{radius.distance}</span>
                <span className="text-sm">{radius.time}</span>
              </div>
              <img
                src={radius.image}
                alt={radius.distance}
                className={radius.className}
              />
            </div>
          ))}
        </div>
      </div>
      {/* Scores */}
      <div className='scores-section py-10'>
        <div className='text-[28px] font-medium mb-8'>SCORES</div>
        <div className='flex gap-8 justify-center items-center flex-wrap'>
          <img src={GemScore} alt="gem-score" className='h-[250px] w-auto' />
          <img src={FeelScore} alt="feel-score" className='h-[250px] w-auto' />
        </div>
      </div>

      {otherFeatures()}
      {/* COMPARE ADDRESSES */}
      <div className="flex flex-col gap-y-6 text-center px-4 py-12 max-w-screen-2xl mx-auto">
        <div>
          <div className="text-[28px] font-medium">COMPARE NEIGHBORHOODS</div>
          <span className='text-xl'>up-to 4 addresses</span>
        </div>
        <img
          src={Comparison}
          alt="Neighborhood Gems"
          className="w-full"
        />
      </div>
      {/* NEIGHBORHOOD REPORT */}
      <div className="flex flex-col gap-y-6 text-center px-4 py-12 max-w-screen-2xl mx-auto">
        <div>
          <div className="text-[28px] font-medium">NEIGHBORHOOD REPORT</div>
          <span className='text-xl'>1189 W 89TH ST, PH 1</span>
        </div>
        <div className='text-[24px]'>UPPER WEST SIDE</div>
        <img
          src={GemReport}
          alt="Neighborhood Gems"
          className="w-full"
        />
        <img
          src={FeelReport}
          alt="Neighborhood Gems"
          className="w-full"
        />
      </div>
    </div>
  );
};

export default Home;
